import React from 'react';
import moment from 'moment';
import GeckoLocation from 'services/gecko-location';
import FilterBar from '../../components/FilterBar';
import {
  GeckoCardTable,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoModal,
  GeckoIcon,
  GeckoAvatar,
} from 'ui';
import { useRatings } from './useRatings';

import './index.scss';

const DATE_FORMAT = 'Do MMM YYYY [at] HH:mm';

const goToConversation = (row) =>
  GeckoLocation.goTo(
    `/conversations/${row.conversation.id}?contact=${row.user.id}&filter=Contact`
  );

const cols = [
  {
    key: 'icon',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM,
    render: (_, row) => (
      <div onClick={() => (row.user ? goToConversation(row) : null)}>
        <GeckoIcon icon="far fa-comments" />
      </div>
    ),
    align: 'center',
  },
  {
    key: 'user.full_name',
    name: 'Contact',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM,
    render: (name) => {
      if (name) {
        return (
          <>
            <GeckoAvatar name={name} />
            {name}
          </>
        );
      }
      return <>{'Contact Deleted'}</>;
    },
  },
  {
    key: 'rating_score',
    name: 'Rating',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT,
    sortable: true,
  },
  {
    key: 'comment',
    name: 'Comment',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT,
  },
  {
    key: 'conversation.first_channel.name',
    name: 'Channel',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT,
  },
  {
    key: 'bot.name',
    name: 'Bot Name',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM,
    align: 'center',
    render: (name) => {
      return <>{name || '-'}</>;
    },
  },
  {
    key: 'createdAt',
    name: 'Date',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DATE,
    format: DATE_FORMAT,
    sortable: true,
  },
];

const Ratings = () => {
  const {
    filters,
    feedback,
    pagination,
    handleFiltersChange,
    extraFilterProps,
  } = useRatings();

  const openRatingModal = (row) => {
    return new GeckoModalService().open(() => (
      <GeckoModal
        name="Conversation Rating"
        btns={[
          {
            name: 'Close',
            icon: 'far fa-times',
            handler: () => {
              new GeckoModalService().close();
            },
          },
          {
            name: 'View Conversation',
            type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
            icon: 'far fa-comments',
            hideWhen: () => !row.user,
            handler: () => {
              new GeckoModalService().close();
              goToConversation(row);
            },
          },
        ]}
      >
        <div className="rating-modal-container">
          <div>
            <h3>Contact</h3>
            <p>{row.user?.full_name || 'Contact Deleted'}</p>
          </div>
          <div>
            <h3>Rating</h3>
            <p>{row.rating_score}</p>
          </div>
          <div>
            <h3>Comment</h3>
            <p>{row.comment}</p>
          </div>
          <div>
            <h3>Channel</h3>
            <p>{row.conversation.first_channel.name}</p>
          </div>
          {row.bot && (
            <div>
              <h3>Bot Name</h3>
              <p>{row.bot.name}</p>
            </div>
          )}
          <div>
            <h3>Date</h3>
            <p>{moment(row.createdAt).format(DATE_FORMAT)}</p>
          </div>
        </div>
      </GeckoModal>
    ));
  };

  return (
    <div className="Stats-Ratings">
      <FilterBar
        filterByDates
        filterByAgents
        filterByChannels
        filterByRatings
        filterByBots
        startDate={filters.startDate}
        endDate={filters.endDate}
        filter={handleFiltersChange}
        {...extraFilterProps}
      />
      <div className="Stats-Ratings-Table">
        <GeckoCardTable
          name="Conversation Ratings"
          cols={cols}
          rows={feedback}
          rowHandler={openRatingModal}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default Ratings;
